module.exports = __webpack_public_path__ + "coffee-script/package.json";


//////////////////
// WEBPACK FOOTER
// ./~/coffee-script/package.json
// module id = 587
// module chunks = 0